import { createStyle } from '@gluestack-style/react';

export const FormControlErrorText = createStyle({
  flex: 1,
  flexShrink: 1,
  minWidth: 0,
  textAlign: 'left',
  color: '$error700',
  _dark: {
    color: '$error400',
  },
});
